function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "9",
  height: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.9 1.271l2.91 3.183a.389.389 0 00.566.014.43.43 0 00.014-.589L5.066.244a.78.78 0 00-1.138.007L.61 3.88a.424.424 0 00-.11.288c0 .11.042.22.124.302.16.158.413.152.566-.015L4.1 1.258v8.325c0 .23.18.417.4.417.22 0 .4-.187.4-.417V1.271z",
  fill: "#39C696",
  fillRule: "nonzero"
})));